import { Layout } from "../components/funnel";
import { ReplayTop } from "../components/replay/ReplayTop";
import { ReplayHero, Stall } from "../components/replay/ReplayHero";
import { Mentorship, Week } from "../components/replay/Mentorship";
import { Myths } from "../components/replay/Myths";
import { Enroll } from "../components/replay/Enroll";
import { Faq } from "../components/replay/Faq";

export default function ReplayPage() {
  return (
    <Layout chrome={false} footerVariant="replay" top={<ReplayTop />}>
      <ReplayHero />
      <Stall />
      <Mentorship />
      <Week />
      <Myths />
      <Enroll />
      <Faq />
    </Layout>
  );
}
